import { render } from "./SlideCards1.vue?vue&type=template&id=34ef7d73&scoped=true"
import script from "./SlideCards1.vue?vue&type=script&lang=js"
export * from "./SlideCards1.vue?vue&type=script&lang=js"

import "./SlideCards1.vue?vue&type=style&index=0&id=34ef7d73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ef7d73"]])

export default __exports__